import React from 'react'
import screens from '../screens'
import MapBackground from '../components/backgrounds/MapBackground'
import LinesBackground from '../components/backgrounds/LinesBackground'
import ControlImages from '../components/controls/ControlImages'
import Content from '../components/position/Content'
import TopLeft from '../components/position/TopLeft'
import BottomLeft from '../components/position/BottomLeft'
import BottomRight from '../components/position/BottomRight'
import Title from '../components/text/Title'
import BodyText from '../components/text/BodyText'
import CloseButton from '../components/buttons/CloseButton'
import LeftArrowButton from '../components/buttons/LeftArrowButton'
import RightArrowButton from '../components/buttons/RightArrowButton'
import { ReactComponent as BeastmakerHang } from '../assets/beastmakerHang.svg'
import HeliLower from '../assets/heliLower.png'

const Controls5 = ({ navigate, screenOptions }) => (
  <>
    <MapBackground />
    <LinesBackground />

    <Content>
      <Title>CONTROLS</Title>

      <BodyText maxWidth={400}>Jump back on the hangboard to lower your winch</BodyText>

      <ControlImages>
        <img src={HeliLower} alt="helicopter" />
        <BeastmakerHang />
      </ControlImages>
    </Content>

    <TopLeft>
      <CloseButton
        onClick={() => (screenOptions.return ? navigate.changeScreen(screenOptions.return) : navigate.reset())}
      />
    </TopLeft>

    <BottomLeft>
      <LeftArrowButton onClick={() => navigate.changeScreen(screens.CONTROLS4_SCREEN, screenOptions)} />
    </BottomLeft>

    <BottomRight>
      <RightArrowButton onClick={() => navigate.changeScreen(screens.CONTROLS6_SCREEN, screenOptions)} />
    </BottomRight>
  </>
)

export default Controls5
